import { render, staticRenderFns } from "./AllocateForm.vue?vue&type=template&id=dc4d0308&"
import script from "./AllocateForm.vue?vue&type=script&lang=js&"
export * from "./AllocateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports